<template>
    <layout :mainClass="null" :containerized="false">
        <div class="w-100">
            <iframe class="w-100 h-100 border-0" :src="iframeUrl" id="edubookersIframe" allowtransparency="true"></iframe>
        </div>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo() {
        return {
            title: Lang.get('employeedashboard::pages/dashboard/dashboard.meta.title'),
        }
    },
    components: {
        Layout,
    },
    props: {
      iframeUrl: String,
    },
}
</script>
